import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_18456",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 25,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .412109,
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_18456)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5.56593 19H6.80245L16.0621 9.74036L14.8256 8.50381L5.56593 17.7635V19ZM19.2697 8.65576L15.8948 5.31158L17.1987 4.00776C17.4922 3.71417 17.8493 3.56738 18.2698 3.56738C18.6903 3.56738 19.0473 3.71417 19.3409 4.00776L20.5582 5.22503C20.8518 5.51862 21.0037 5.87053 21.014 6.28078C21.0242 6.69103 20.8825 7.04295 20.589 7.33653L19.2697 8.65576ZM18.1852 9.75573L7.4409 20.5H4.06598V17.125L14.8102 6.38078L18.1852 9.75573Z" })
	})]
});
export default SvgEdit;
